import BaseLibraryIconSvg from '../BaseLibraryIconSvg';
import type { IconSvgProps } from '../Icon';

export default function ChevronDown(props: IconSvgProps) {
  return (
    <BaseLibraryIconSvg {...props}>
      <path
        d='M12.0029 17.2746C12.2725 17.2746 12.5281 17.1639 12.716 16.9553L21.719 7.60856C21.8929 7.43 22 7.21365 22 6.94764C22 6.41458 21.5958 6 21.0627 6C20.8117 6 20.5607 6.10819 20.3868 6.27172L11.4279 15.5583H12.5721L3.60856 6.27172C3.43931 6.10819 3.20437 6 2.94764 6C2.4099 6 2 6.41458 2 6.94764C2 7.21365 2.11178 7.43468 2.28567 7.6132L11.2944 16.96C11.4879 17.1685 11.7229 17.2746 12.0029 17.2746Z'
        fill='currentColor'
      />
    </BaseLibraryIconSvg>
  );
}
